<template>
  <FitHalfScreenDialogV2
    :class="[language.getLanguage(), 'subway-tip-dialog-wrapper']"
    ref="subwayTipDialog"
    :isHideHeader="true"
    :isAppendToBody="true"
  >
    <div slot="bd" class="subway-tip-dialog" v-stat.brow="'main.subway_tip_dialog'">
      <div class="title">
        <div>{{ i18n('在內地地鐵乘車，你可通過以下2種方式購買地鐵車票') }}</div>
        <div class="desc">{{ i18n('目前WeChat Pay HK已支持深圳、廣州、長沙等城市購買地鐵車票。') }}</div>
      </div>
      <div class="info-wrapper">
        <div class="info-item">
          <div class="info-title">{{ i18n('方式1：人工售票窗口買票') }}</div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ i18n('方式2：自動售票機買票') }}</div>
        </div>
      </div>
      <FitButton v-stat.click="'main.subway_tip_dialog_close'" class="btn" type="default" @click="onHideDialog">
        {{ i18n('我知道了') }}
      </FitButton>
    </div>
  </FitHalfScreenDialogV2>
</template>

<script setup lang="ts">
import { FitHalfScreenDialogV2, FitButton } from '@tencent/wphk-ui';
import { i18n } from '@/i18n';
import { ref } from 'vue';
import { language } from '@tencent/ppd-base-libs';

// 暴露方法
defineExpose({ onShowDialog });

// 地铁说明弹窗
const subwayTipDialog = ref<InstanceType<typeof FitHalfScreenDialogV2> | null>(null);

// 打开弹窗
function onShowDialog() {
  subwayTipDialog.value?.showDialog();
}

// 关闭弹窗
function onHideDialog() {
  subwayTipDialog.value?.hideDialog();
}
</script>

<style lang="less">
@import (reference) '~@/less/main';
.subway-tip-dialog-wrapper {
  .weui-half-screen-dialog {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>

<style lang="less" scoped>
@import (reference) '~@/less/main';
.subway-tip-dialog {
  .title {
    padding: 32 / @rem;
    .font-28-regular(rgba(0,0,0,0.9));
    .divider_bottom();
    margin-bottom: 10 / @rem;
    .desc {
      .font-28-regular(rgba(0,0,0,0.5));
      margin-top: 8 / @rem;
    }
  }
  .info-wrapper {
    padding: 0 / @rem 32 / @rem;
    margin-bottom: 80 / @rem;
    .info-item {
      padding: 32 / @rem 0;
      .divider_bottom();
      &:last-child::after {
        display: none;
      }
      .info-title {
        .font-34-medium(rgba(0,0,0,0.9));
      }
      .info-desc {
        .font-28-regular(rgba(0,0,0,0.5));
        margin-top: 8 / @rem;
      }
    }
  }
  .btn {
    display: flex;
    align-items: center;
    width: 368 / @rem;
    margin-bottom: 72 / @rem;
  }
}
</style>
